
import {defineComponent} from 'vue';
import Api from "@/components/core/Api.vue";
import ShopMenu from '@/components/layout/ShopMenu.vue';
import Sidebar from '@/components/layout/Sidebar.vue';

export default defineComponent({
  name: 'Header',
  components: {
    Api,
    ShopMenu,
    Sidebar
  },
  data() {
    return {
      ActiveShop: false,
      ActiveSidebar: false,
      categories: [],
      topStore: [
        {"href": "https://rebatekey.com/amazon", name: "Amazon", ico: "amazon"},
        {"href": "https://rebatekey.com/ebay", name: "eBay", ico: "ebay"},
        {"href": "https://rebatekey.com/shopify", name: "Shopify", ico: "shopify"},
        {"href": "https://rebatekey.com/walmart", name: "Walmart", ico: "walmart"},
        {"href": "https://rebatekey.com/etsy", name: "Etsy", ico: "etsy"}
      ],
      store: [
        {"href": "https://rebatekey.com/shop/academy-sports", name: "Academy Sports"},
        {"href": "https://rebatekey.com/shop/aliexpress", name: "AliExpress"},
        {"href": "https://rebatekey.com/shop/art-naturals", name: "Art Naturals"},
        {"href": "https://rebatekey.com/shop/att-mobility", name: "AT&T Mobility"},
        {"href": "https://rebatekey.com/shop/autoanything", name: "AutoAnything"},
        {"href": "https://rebatekey.com/shop/bebe", name: "Bebe"},
        {"href": "https://rebatekey.com/shop/brookstone", name: "Brookstone"},
        {"href": "https://rebatekey.com/shop/camelbak", name: "CamelBak"},
        {"href": "https://rebatekey.com/shop/canon", name: "Canon"},
        {"href": "https://rebatekey.com/shop/clarks", name: "Clarks"},
        {"href": "https://rebatekey.com/shop/crayola", name: "Crayola"},
        {"href": "https://rebatekey.com/shop/dell-refurbished-computers", name: "Dell Financial Services"},
        {"href": "https://rebatekey.com/shop/everlast", name: "Everlast"},
        {"href": "https://rebatekey.com/shop/evitamins", name: "eVitamins"},
        {"href": "https://rebatekey.com/shop/evite", name: "Evite"},
        {"href": "https://rebatekey.com/shop/forever-21", name: "Forever 21"},
        {"href": "https://rebatekey.com/shop/fossil", name: "Fossil"},
        {"href": "https://rebatekey.com/shop/g-star-raw-usa", name: "G-Star RAW"},
        {"href": "https://rebatekey.com/shop/gillette-company", name: "Gillette"},
        {"href": "https://rebatekey.com/shop/godaddy", name: "GoDaddy"},
        {"href": "https://rebatekey.com/shop/gopro", name: "GoPro"},
        {"href": "https://rebatekey.com/shop/haggar", name: "Haggar"},
        {"href": "https://rebatekey.com/shop/hobby-lobby", name: "Hobby Lobby"},
        {"href": "https://rebatekey.com/shop/harman", name: "JBL"},
        {"href": "https://rebatekey.com/shop/kipling", name: "Kipling"},
        {"href": "https://rebatekey.com/shop/shop-kitchen-aid", name: "Kitchen Aid"},
        {"href": "https://rebatekey.com/shop/lindt-chocolatier", name: "Lindt Chocolatier"},
        {"href": "https://rebatekey.com/shop/lucky-brand", name: "Lucky Brand"},
        {"href": "https://rebatekey.com/shop/my-mms", name: "M&M&apos;s"},
        {"href": "https://rebatekey.com/shop/moosejaw", name: "Moosejaw"},
        {"href": "https://rebatekey.com/shop/nordstrom-rack", name: "Nordstrom Rack"},
        {"href": "https://rebatekey.com/shop/office-depot-and-officemax", name: "Office Depot and OfficeMax"},
        {"href": "https://rebatekey.com/shop/party-city", name: "Party City"},
        {"href": "https://rebatekey.com/shop/perry-ellis", name: "Perry Ellis"},
        {"href": "https://rebatekey.com/shop/puma", name: "PUMA"},
        {"href": "https://rebatekey.com/shop/radisson-hotels", name: "Radisson Hotels"},
        {"href": "https://rebatekey.com/shop/roku", name: "Roku"},
        {"href": "https://rebatekey.com/shop/samsung", name: "Samsung"},
        {"href": "https://rebatekey.com/shop/shop-disney", name: "Shop Disney"},
      ]
    }
  }
});
